import * as React from "react";
import { IInvestigatorInPlay } from "./Scenario";
import { DeckComponent } from "./DeckComponent";
import { ICard, ICardReference, CardType, CardSubType, IDeckBrowserFilter, IPlayerCard, ICustomDeckBuilderRule } from "./Card";
import { Stock } from "./Stock";
import { DeckBrowserComponent, } from "./DeckBrowserComponent";
import { PlayerDeckBrowserComponent } from "./PlayerDeckBrowserComponent";
import { IDeck } from "./Deck";
import { CardUtil } from "./CardUtil";


interface ICustomizeDeckState {
    experienceLeft: number;
    freePlayerCards: IPlayerCard[];
    playerCards: IPlayerCard[];
}
export interface ICustomizeDeckProps {
    investigator: IInvestigatorInPlay;
    onDone: (investigator: IInvestigatorInPlay) => void;
}
export class CustomizeDeckComponent extends React.Component<ICustomizeDeckProps, ICustomizeDeckState> {
    private readonly availableCards: ICard[];

    constructor(props: ICustomizeDeckProps) {
        super(props);
        this.availableCards = Stock.getAllPlayerCardsForDeckCustomization();

        //remove all non standard cards
        const cards = this.props.investigator.deck.cards.filter(c => {
            switch (c.subType) {
                case CardSubType.Neutral:
                case CardSubType.Guardian:
                case CardSubType.Seeker:
                case CardSubType.Rouge:
                case CardSubType.Mystic:
                case CardSubType.Survivor:
                    return true;
                default:
                    return false;
            }
        });

        //sort 
        cards.sort((a, b) => {
            if (a.pack < b.pack) return -1;
            if (a.pack > b.pack) return 1;
            if (a.packNumber < b.packNumber) return -1;
            if (a.packNumber > b.packNumber) return 1;
            return 0;
        });
        let lastPlayerCard: IPlayerCard = null;
        const playerCards: IPlayerCard[] = [];
        let playerFreeCards: ICardReference[] = this.props.investigator.card.values["freeCards"];
        if (this.props.investigator.freeCards)
            playerFreeCards = playerFreeCards.concat(this.props.investigator.freeCards);
        const freePlayerCards: IPlayerCard[] = playerFreeCards.map(cr => {
            const c = Stock.getCard(cr);
            c.faceUp = true;
            return { card: c, amount: 1, key: CardUtil.getKey(c) };
        });
        const randomWeakness = Stock.getRandomCardOfType(CardType.Treachery, CardSubType.BasicWeakness);
        randomWeakness.name = "<Random Weakness>";
        randomWeakness.faceUp = false;
        freePlayerCards.push({ card: randomWeakness, amount: 1, key: "randomWeakness" });
        for (let i = 0; i < cards.length; i++) {
            const c = cards[i];
            const key = CardUtil.getKey(c);
            if (lastPlayerCard && lastPlayerCard.key === key) {
                lastPlayerCard.amount++;
            } else {
                lastPlayerCard = {
                    card: ({ ...c }),
                    amount: 1,
                    key: key
                };
                lastPlayerCard.card.faceUp = true;

                playerCards.push(lastPlayerCard);
            }

        }

        this.state = { experienceLeft: this.props.investigator.experience, playerCards: playerCards, freePlayerCards: freePlayerCards };
    }

    calculateCardsLeft(): number {
        let cardsLeft = this.props.investigator.card.values["maxDeckSize"];
        this.state.playerCards.forEach(pc => {
            cardsLeft -= pc.amount;
        });
        return cardsLeft;
    }
    sellCard(cardReference: ICardReference) {
        const playerCards = this.state.playerCards;
        for (let i = 0; i < playerCards.length; i++) {
            const pc = playerCards[i];
            if (CardUtil.equals(pc.card, cardReference)) {
                let xp = this.state.experienceLeft;
                xp += pc.card.xpCost;
                pc.amount--;
                if (pc.amount <= 0)
                    playerCards.splice(i, 1);
                this.setState({ playerCards: playerCards, experienceLeft: xp });
                return;
            }
        }
    }
    buyCard(cardReference: ICardReference) {
        const card = Stock.getCard(cardReference);
        let xp = this.state.experienceLeft;
        if (card.xpCost > xp) {
            alert("Card is too expencive. You need " + card.xpCost + " experience to buy it!");
            return;
        }
        if (this.calculateCardsLeft() <= 0) {
            alert("You have reached the card limit for the investigator. You cannot buy anymore cards until you sell some.");
            return;
        }
        xp -= card.xpCost;
        const playerCards = this.state.playerCards;
        const matchingCards = playerCards.filter(pc => { return CardUtil.equals(cardReference, pc.card) });
        let playerCard: IPlayerCard;
        if (matchingCards.length > 0) {
            playerCard = matchingCards[0];
        } else {
            playerCard = { card: card, amount: 0, key: CardUtil.getKey(card) };
            playerCards.push(playerCard);
        }
        playerCard.amount++;
        this.setState({ playerCards: playerCards, experienceLeft: xp });
        return;
    }

    render() {
        const invDeck: IDeck = { cards: [({ ...this.props.investigator.card })] };
        const invFilter: IDeckBrowserFilter = {
            maxNeutralLevel: this.props.investigator.card.values["maxNeutralLevel"],
            maxGuardianLevel: this.props.investigator.card.values["maxGuardianLevel"],
            maxSeekerLevel: this.props.investigator.card.values["maxSeekerLevel"],
            maxRougeLevel: this.props.investigator.card.values["maxRougeLevel"],
            maxMysticLevel: this.props.investigator.card.values["maxMysticLevel"],
            maxSurvivorLevel: this.props.investigator.card.values["maxSurvivorLevel"],
            hiddenCards: this.state.playerCards.filter(pc => pc.amount > 1).map(pc => pc.card),
            uniqueCards: this.state.playerCards.filter(pc => pc.card.unique).map(pc => pc.card.name)
        };
        //reload card from stock since a saved state doesn't contain the rules
        const invCard = Stock.getCard(this.props.investigator.card);
        const cr = invCard.values[CardUtil.customDeckBuilderRulesKey] as ICustomDeckBuilderRule[];
        if (cr && cr.length) {
            cr.forEach(rule => {
                if(rule)
                rule.modifyFilter(this.state.playerCards, invFilter);
            });
        }
        invDeck.cards[0].faceUp = false;
        return (
            <div className="container-fluid">
                <div className="col-md-12 p-t-30">
                    <div className="bordered-content customize-deck">
                        <div className="content-box">
                            <div className="row">
                                <div className="col-md-4 available-cards">
                                    <DeckBrowserComponent
                                        deck={{ cards: this.availableCards }}
                                        filter={invFilter}
                                        onBuyCard={(cr) => { this.buyCard(cr); }} />
                                </div>
                                <div className="col-md-4 player-info">
                                    <DeckComponent deck={invDeck} horizontal={true} settings={{ hideTokensOnBack: true, toolbar: { zoom: true, flip: false } }} />
                                    <div className="player-stats">
                                        <div>
                                            <span className="card-token player-token">{this.calculateCardsLeft()}</span> cards left
                                        </div>
                                        <div className="p-t-10">
                                            <span className="xp-token player-token">{this.state.experienceLeft}</span> experience left
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 player-cards">
                                    <PlayerDeckBrowserComponent
                                        investigator={this.props.investigator}
                                        freePlayerCards={this.state.freePlayerCards}
                                        playerCards={this.state.playerCards}
                                        onSellCard={(cr) => { this.sellCard(cr); }} />
                                </div>
                            </div>
                            <div className="row button-row">
                                <button onClick={() => this.cancel()}>Cancel</button>
                                <button onClick={() => this.save()}>Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    cancel() {
        this.props.onDone(null);
    }

    save() {
        let cardsLeft = this.calculateCardsLeft();
        if (cardsLeft !== 0) {
            alert(`Cannot save deck. You need to buy ${cardsLeft} more cards until you reach your limit.`);
            return;
        }
        if (this.state.experienceLeft < 0) {
            alert("Cannot save deck. You have exceeded your experience limit.");
            return;
        }
        this.props.investigator.experience = this.state.experienceLeft;
        this.props.investigator.deck = this.createDeck();
        this.props.onDone(this.props.investigator);
    }

    createDeck(): IDeck {
        let playerFreeCards: ICardReference[] = this.props.investigator.card.values["freeCards"];
        if (this.props.investigator.freeCards)
            playerFreeCards = playerFreeCards.concat(this.props.investigator.freeCards);

        const cards = playerFreeCards.map(cr => {
            return Stock.getCard(cr);
        });
        const randomWeakness = Stock.getRandomCardOfType(CardType.Treachery, CardSubType.BasicWeakness);
        cards.push(randomWeakness);
        for (let i = 0; i < this.state.playerCards.length; i++) {
            const pc = this.state.playerCards[i];
            for (let j = 0; j < pc.amount; j++) {
                const c = Stock.getCard(pc.card);
                cards.push(c);
            }
        }
        //make all cards face down and shuffle them
        CardUtil.flip(cards, false);
        CardUtil.shuffle(cards);
        return { cards: cards };
    }
}
